import { Injectable, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Subject } from '../models/subject';
import { User } from '../models/user';
import { SettingsData } from './default-data.service';
import { SystemSetting } from './system-settings.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root' })
export class EventService implements OnDestroy {
    
    onViewSubject: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);
    onSubjectMarkedAsDirty: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onAddSubject: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);
    onDeleteSubject: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);
    onUpdateSubject: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);    
    onUpdateTaskStats: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);    
    
    onUpdateSubjectStats: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);
    onUpdateReferralStats: ReplaySubject<Subject> = new ReplaySubject<Subject>(1, 100);
    onChangeSettings: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onChangeUser: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onAcceptSubject: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onRejectSubject: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onReviewSubject: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onChecklistRecordAdded : ReplaySubject<any>  = new ReplaySubject<any>(1, 100);

    onFileUploaded: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onFileDownloaded: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onFileDeleted: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onFilesUpdated: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onUpdateTimeRecord: ReplaySubject<any> = new ReplaySubject<any>(1, 100);

    onUpdateLimitAccess: ReplaySubject<any> = new ReplaySubject<any>(1, 100);
    onUpdateHyperLawLicenceValid: ReplaySubject<boolean> = new ReplaySubject<boolean>(1, 100);

    onUpdateSubjectsDueReviewStats:  ReplaySubject<any> = new ReplaySubject<any>(1, 100);

    onReportItemChanged: ReplaySubject<any> = new ReplaySubject<any>(1);
    onReportDataChanged: ReplaySubject<any> = new ReplaySubject<any>(1, 100);

    onGenerateReportStarted: ReplaySubject<any> = new ReplaySubject<any>(1);
    onGenerateReportCompleted : ReplaySubject<any> = new ReplaySubject<any>(1);

    constructor() { }

    ngOnDestroy(): void {
      
    }

    viewSubject(subject: Subject) {
        if (subject) {
            this.onViewSubject.next(subject);
        }
    }

    markSubjectAsDirty(subjectId: number, message?: string) {
        if (subjectId) {
            this.onSubjectMarkedAsDirty.next({ subjectId, message });
        }
    }

    addSubject(subject: Subject) {
        if (subject) {
            this.onAddSubject.next(subject);
        }
    }

    deleteSubject(subject: Subject) {
        if (subject) {
            this.onDeleteSubject.next(subject);
        }
    }

    updateSubject(subject: Subject) {        
        if (subject) {            
            this.onUpdateSubject.next(subject);
        }
    }

    acceptSubject(subject: Subject) {
        if (subject) {
            this.onAcceptSubject.next(subject);
        }
    }

    rejectSubject(subject: Subject) {
        if (subject) {
            this.onRejectSubject.next(subject);
        }
    }

    reviewSubject(subject: Subject) {
        if (subject) {
            this.onReviewSubject.next(subject);
        }
    }

    updateTaskStats() {
        this.onUpdateTaskStats.next(undefined);
    }

    updateSubjectStats() {
        this.onUpdateSubjectStats.next(undefined);
    }

    updateSubjectsDueReviewStats(){
        this.onUpdateSubjectsDueReviewStats.next(undefined);
    }

    updateReferralStats() {
        this.onUpdateReferralStats.next(undefined);
    }

    updateSettings(settings: SettingsData | SystemSetting) {
        this.onChangeSettings.next(settings);
    }

    updateUser(user: User) {
        this.onChangeUser.next(user);
    }

    fileUploaded() {
        this.onFileUploaded.next(undefined);
    }

    fileDownloaded(fileName: string) {
      this.onFileDownloaded.next(fileName);
  }

    fileDeleted() {
        this.onFileDeleted.next(undefined);
    }

    filesUpdated() {
        this.onFilesUpdated.next(undefined);
    }

    updateTimeRecord() {
        this.onUpdateTimeRecord.next(undefined);
    }

    updateLimitAccess(val: boolean) {
        this.onUpdateLimitAccess.next(val);
    }

    updateHyperLawLicenceValid(val: boolean) {
        this.onUpdateHyperLawLicenceValid.next(val);
    }

    reportItemChanged(val: any) {
        this.onReportItemChanged.next(val);
    }

    reportDataChanged(val: any) {
        this.onReportDataChanged.next(val);
    }

    generateReportStarted() {
        this.onGenerateReportStarted.next(1);      
    }
    generateReportCompleted() {
        this.onGenerateReportCompleted.next(1);      
    }

    ChecklistRecordAdded(subject)
    {
        if (this.onChecklistRecordAdded)
        {
            // Wait a second for the checklist to update
            window.setTimeout(() => { 
                console.log("Sending Update Checklist widget Signal")
                this.onChecklistRecordAdded.next(subject); 
            }, 1000);            
        }
    }
}
